import { render, staticRenderFns } from "./dqCodeForm.vue?vue&type=template&id=083b40ec&scoped=true&"
import script from "./dqCodeForm.vue?vue&type=script&lang=js&"
export * from "./dqCodeForm.vue?vue&type=script&lang=js&"
import style0 from "./dqCodeForm.vue?vue&type=style&index=0&id=083b40ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083b40ec",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QInput,QSelect});
